import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AisVesselsComponent } from './ais-vessels.component';

const routes: Routes = [
  {
    path: '',
    component: AisVesselsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AisVesselsRoutingModule {}
